"use strict";

var _createClass = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var three_1 = require("three");
/**
 * A `Vector` in 2D space is the base entity manipulated by the `Optimizer`. All higher-level
 * entities (like simple and compound nodes, ports, etc.) are represented as a collection of points.
 */


var Vector =
/*#__PURE__*/
function (_three_1$Vector) {
  _inherits(Vector, _three_1$Vector);

  function Vector() {
    _classCallCheck(this, Vector);

    return _possibleConstructorReturn(this, _getPrototypeOf(Vector).apply(this, arguments));
  }

  return Vector;
}(three_1.Vector2);

exports.Vector = Vector;
/**
 * A `Gradient` associates a point `Vector` to a gradient `Vector` that the `Optimizer` uses to
 * update the point's location in space. A `Gradient` can act as a "soft" force or a "hard"
 * constraint depending on how aggressively the `Optimizer` enforces it (through the learning rate).
 */

var Gradient = function Gradient(point, grad) {
  _classCallCheck(this, Gradient);

  this.point = point;
  this.grad = grad;
};

exports.Gradient = Gradient;
/**
 * An `Optimizer` performs an update to a `Vector` based on a `Gradient`. It uses *gradient ascent*,
 * which means that the gradient vector should already point in the intended direction of update and
 * the update rule takes the form: `x = x + lr * grad`. This fits with the physical iterpretation
 * of a gradient as a "nudge" in a particular direction due to forces or constraints.
 */

var Optimizer = function Optimizer() {
  _classCallCheck(this, Optimizer);
};

exports.Optimizer = Optimizer;
/**
 * A `BasicOptimizer` uses a fixed learning rate and decay factor.
 */

var BasicOptimizer =
/*#__PURE__*/
function (_Optimizer) {
  _inherits(BasicOptimizer, _Optimizer);

  function BasicOptimizer() {
    var _this;

    var lr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var decay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, BasicOptimizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BasicOptimizer).call(this));
    _this.lr = lr;
    _this.decay = decay;
    return _this;
  }

  _createClass(BasicOptimizer, [{
    key: "step",
    value: function step(gradients) {
      var _this2 = this;

      gradients.forEach(function (_ref) {
        var grad = _ref.grad,
            point = _ref.point;
        return point.addScaledVector(grad, _this2.lr);
      });
    }
  }, {
    key: "update",
    value: function update() {
      this.lr = Math.max(this.lr * this.decay, 0.01);
    }
  }]);

  return BasicOptimizer;
}(Optimizer);

exports.BasicOptimizer = BasicOptimizer;
/**
 * A `ScheduledOptimizer` uses a variable learning rate set by a `Scheduler`.
 */

var ScheduledOptimizer =
/*#__PURE__*/
function (_Optimizer2) {
  _inherits(ScheduledOptimizer, _Optimizer2);

  function ScheduledOptimizer(scheduler) {
    var _this3;

    _classCallCheck(this, ScheduledOptimizer);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ScheduledOptimizer).call(this));
    _this3.scheduler = scheduler;
    _this3._timestep = 0;
    _this3._lr = scheduler.get(0);
    return _this3;
  }

  _createClass(ScheduledOptimizer, [{
    key: "step",
    value: function step(gradients) {
      var _this4 = this;

      gradients.forEach(function (_ref2) {
        var grad = _ref2.grad,
            point = _ref2.point;
        return point.addScaledVector(grad, _this4._lr);
      });
    }
  }, {
    key: "update",
    value: function update() {
      this._timestep += 1;
      this._lr = this.scheduler.get(this._timestep);
    }
  }]);

  return ScheduledOptimizer;
}(Optimizer);

exports.ScheduledOptimizer = ScheduledOptimizer;
/**
 * A `EnergyOptimizer` uses an adaptive scheme to increase or decrease the learning rate based
 * on whether there is improvement on an energy function (lower than before). The energy function
 * is the squared norm of all the gradients between successive `update()` calls.
 */

var EnergyOptimizer =
/*#__PURE__*/
function (_Optimizer3) {
  _inherits(EnergyOptimizer, _Optimizer3);

  function EnergyOptimizer() {
    var _this5;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, EnergyOptimizer);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(EnergyOptimizer).call(this));
    _this5._numStepsImproved = 0;
    _this5._currEnergy = 0;
    var _config$lrInitial = config.lrInitial,
        lrInitial = _config$lrInitial === void 0 ? 1 : _config$lrInitial,
        _config$wait = config.wait,
        wait = _config$wait === void 0 ? 5 : _config$wait,
        _config$lrMax = config.lrMax,
        lrMax = _config$lrMax === void 0 ? 1 : _config$lrMax,
        _config$lrMin = config.lrMin,
        lrMin = _config$lrMin === void 0 ? 0.01 : _config$lrMin,
        _config$decay = config.decay,
        decay = _config$decay === void 0 ? 0.9 : _config$decay,
        _config$growth = config.growth,
        growth = _config$growth === void 0 ? 1.1 : _config$growth,
        _config$smoothing = config.smoothing,
        smoothing = _config$smoothing === void 0 ? 0.1 : _config$smoothing;
    if (decay > 1) throw Error('Must specify value of `decay` <= 1');
    if (growth < 1) throw Error('Must specify value of `growth` >= 1');
    if (wait < 0) throw Error('Must specify value of `wait` >= 0');
    _this5._config = {
      lrInitial: lrInitial,
      lrMax: lrMax,
      lrMin: lrMin,
      wait: wait,
      decay: decay,
      growth: growth,
      smoothing: smoothing
    };
    _this5._lr = lrInitial;
    return _this5;
  }

  _createClass(EnergyOptimizer, [{
    key: "step",
    value: function step(gradients) {
      var _this6 = this;

      var energy = 0;
      gradients.forEach(function (grad) {
        grad.point.add(grad.grad.clone().multiplyScalar(_this6._lr));
        energy += grad.grad.length();
      });
      energy /= gradients.length + 1;
      this._currEnergy += energy;
    }
  }, {
    key: "update",
    value: function update() {
      if (!this._prevEnergy) this._prevEnergy = this._currEnergy;

      if (this._currEnergy < this._prevEnergy) {
        this._numStepsImproved += 1;

        if (this._numStepsImproved >= this._config.wait) {
          // Steady improvement, so increase learning rate.
          this._numStepsImproved = 0;
          this._lr = Math.min(this._config.growth * this._lr, this._config.lrMax); // console.log('improve', this._lr, this._currEnergy, this._prevEnergy);
        }
      } else if (this._currEnergy > this._prevEnergy) {
        // No improvement, so decrease learning rate.
        this._numStepsImproved = 0;
        this._lr = Math.max(this._config.decay * this._lr, this._config.lrMin); // console.warn('no improve', this._lr, this._currEnergy, this._prevEnergy);
      }

      this._prevEnergy *= this._config.smoothing;
      this._prevEnergy += (1 - this._config.smoothing) * this._currEnergy;
      this._currEnergy = 0;
    }
  }]);

  return EnergyOptimizer;
}(Optimizer);

exports.EnergyOptimizer = EnergyOptimizer;
/**
 * A `RMSPropOptimizer` uses an adaptive scheme based on a per-parameter moving weighted average of
 * magnitudes.
 */

var RMSPropOptimizer =
/*#__PURE__*/
function (_Optimizer4) {
  _inherits(RMSPropOptimizer, _Optimizer4);

  function RMSPropOptimizer() {
    var _this7;

    var lr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var smoothing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.99;

    _classCallCheck(this, RMSPropOptimizer);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(RMSPropOptimizer).call(this));
    _this7.lr = lr;
    _this7.smoothing = smoothing;
    _this7._square_avgs = new Map();
    return _this7;
  }

  _createClass(RMSPropOptimizer, [{
    key: "step",
    value: function step(gradients) {
      var _this8 = this;

      gradients.forEach(function (_ref3) {
        var grad = _ref3.grad,
            point = _ref3.point;
        // Calculate smoothed average of squared gradients.
        var square_avg = _this8._square_avgs.get(point) || new Vector(0, 0);
        square_avg = square_avg.multiplyScalar(_this8.smoothing).addScaledVector(grad.clone().multiply(grad), 1 - _this8.smoothing);

        _this8._square_avgs.set(point, square_avg);

        point.x += _this8.lr * grad.x / (Math.sqrt(square_avg.x) + 1e-3);
        point.y += _this8.lr * grad.y / (Math.sqrt(square_avg.y) + 1e-3);
      });
    }
  }, {
    key: "update",
    value: function update() {}
  }]);

  return RMSPropOptimizer;
}(Optimizer);

exports.RMSPropOptimizer = RMSPropOptimizer;
/**
 * A `TrustRegionOptimizer` uses an adaptive scheme that increasing the learning rate if the
 * gradients are growing, and decreasing the learning rate if the gradients are shrinking.
 */

var TrustRegionOptimizer =
/*#__PURE__*/
function (_Optimizer5) {
  _inherits(TrustRegionOptimizer, _Optimizer5);

  function TrustRegionOptimizer() {
    var _this9;

    var lr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.6;
    var adaption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.1;
    var smoothing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;
    var lrMax = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var lrMin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.00001;

    _classCallCheck(this, TrustRegionOptimizer);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(TrustRegionOptimizer).call(this));
    _this9.lr = lr;
    _this9.adaption = adaption;
    _this9.smoothing = smoothing;
    _this9.lrMax = lrMax;
    _this9.lrMin = lrMin;
    _this9._norm_avgs = new Map();
    _this9._lrs = new Map();
    return _this9;
  }

  _createClass(TrustRegionOptimizer, [{
    key: "step",
    value: function step(gradients) {
      var _this10 = this;

      gradients.forEach(function (_ref4) {
        var grad = _ref4.grad,
            point = _ref4.point;
        // Calculate smoothed averages of squared gradients.
        var norm_avg = _this10._norm_avgs.get(point) || grad.length();
        norm_avg = norm_avg * _this10.smoothing + grad.length() * (1 - _this10.smoothing);

        _this10._norm_avgs.set(point, norm_avg); // Increase learning rate if gradients are growing.


        var lr = _this10._lrs.get(point) || _this10.lr;

        lr = grad.length() / (norm_avg + 1e-3) >= 0.5 ? Math.min(_this10.lrMax, (1 + _this10.adaption) * lr) : Math.max(_this10.lrMin, (1 - _this10.adaption) * lr);

        _this10._lrs.set(point, lr); // console.log(grad.length() > norm_avg, lr);


        point.addScaledVector(grad, lr);
      });
    }
  }, {
    key: "update",
    value: function update() {}
  }]);

  return TrustRegionOptimizer;
}(Optimizer);

exports.TrustRegionOptimizer = TrustRegionOptimizer;